module.exports = __webpack_public_path__ + "assets/371c52ef9af49885977af6fbffe823f9.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-vietnamese-700-normal.woff2
// module id = 2645
// module chunks = 121